import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";

@Component({
    selector: 'app-it-service',
    templateUrl: './it-service.component.html',
    styleUrls: ['./it-service.component.scss']
})
export class ItServiceComponent implements OnInit {
    sectionTitle: any = 'About IT Services';

    constructor(
        private router: Router,
    ) {
    }

    ngOnInit(): void {
    }

    selectSection(section: any): void {
        this.sectionTitle = section;
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }

}
